// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-ef5947ee] .vs-popup {\n  width: 800px !important;\n}\n.accordion[data-v-ef5947ee] {\n  overflow-anchor: none;\n}\n.collapsed > .when-open[data-v-ef5947ee],\n.not-collapsed > .when-closed[data-v-ef5947ee] {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
